module.exports = "/images/everestPath3.png?e9113c8ec890b69791d2c8634e33e965";